import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { GfTranslateService } from '../../core/services/core.translate.service';
import { marker } from '../../core/services/ngx-translate-extract-marker';

@Injectable()
export class BreadcrumbService {
    public newCrumb: any;
    public newItem: any;
    private crumbs: any;
    private callback: any;

    constructor(
        private gfTranslateService: GfTranslateService) {

        this.newItem = function(name, state, params?) {
            return {
                'label': name,
                'state': state,
                'params': params || {}
            };
        }

        this.newCrumb = this.newItem;
    }

    public siteCrumb() {
        return this.translatedCrumb(marker('Site Home'), 'home', {});
    }

    public userMyPageCrumb(user) {
        var unixName = _.get(user, 'unixName', 'Nobody');
        return this.newItem(
            unixName,
            'home.user.my',
            { unixName: unixName }
        );
    }

    public projectCrumb(project) {
        return this.newItem(
            _.get(project, 'name', this.gfTranslateService.translate('Project')),
            'home.project.summary',
            { unixName: _.get(project, 'unixName', '') }
        );
    }

    public stateCrumb(label, state, params) {
        return this.newItem(label, state, params);
    }

    public translatedCrumb(label, state, params) {
        return this.newItem(
            this.gfTranslateService.translate(label),
            state,
            params
        );
    }

    public onCrumbsChange(callback) {
        this.callback = callback;
    }

    public getCrumbs() {
        return this.crumbs;
    }
    
    setCrumbs(crumbs) {
        this.crumbs = crumbs;
        if (typeof this.callback === "function") {
            this.callback(this.crumbs);
        }
        return this.crumbs;
    }
}